import styled from "styled-components";

// Shared code for email, text, and phone send buttons

// Styles
export const ButtonContainer = styled.div`
  margin-top: 10px;
  float: right;
`;

// Utils
export function removeVideoUrls(content: string): string {
  const pattern = /\s*https:\/\/\S*player.vin.media\/\?src\S+\s*/;
  return content.replace(pattern, "\n\n").trim();
}
